import { useContext } from 'react';
import ToastContext from './ToastContext';

/**
 * Hook into the surrounding <ToastProvider />.
 *
 * Returns: { showToast(message, opts?), dismissToast(id) }
 * Opts: { duration?: number } — defaults to 2400 ms.
 */
const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return ctx;
};

export default useToast;
